import React from 'react'
import './TwoImages.css'

function TwoImages() {
  return (
    <>
    <div className='TwoImagesContainer container top'>
        <img src="https://cdn.britannica.com/73/114973-050-2DC46083/Midtown-Manhattan-Empire-State-Building-New-York.jpg" alt="" />
        <img src="https://cdn.britannica.com/73/114973-050-2DC46083/Midtown-Manhattan-Empire-State-Building-New-York.jpg" alt="" />
    </div>
    </>
  )
}

export default TwoImages